import arrow from '../../../assets/images/icons/arrow-minimalistic.svg'
import { Icon } from '../../atoms'
import { SpoilerContainer, SpoilerContent, SpoilerHeader } from './components'
import * as styles from './index.css'

export const Spoiler = (props: {
  state?: 'fold' | 'expand'
  header: React.ReactNode
  children: React.ReactNode
}) => {
  return (
    <SpoilerContainer
      state={props.state || 'fold'}
      className={styles.container}
    >
      <SpoilerHeader
        toggleOnClick={true}
        // className={styles.header}
      >
        {(toggle, state) => (
          <div
            className={styles.header}
            onClick={toggle}
          >
            {props.header}
            <Icon
              src={arrow}
              className={
                state === 'expand' ? styles.arrowIcon : styles.flippedArrowIcon
              }
            />
          </div>
        )}
      </SpoilerHeader>

      <SpoilerContent className={styles.content}>
        {props.children}
      </SpoilerContent>
    </SpoilerContainer>
  )
}
